<template>
  <v-list-tile avatar style="border-bottom: solid 1px lightgray" class="pt-2 pb-2">
    <v-list-tile-avatar
      v-if="comment.comment_id !== editingComment.id"
      id="application-comment-item"
    >
      <img
        :src="'https://people.epfl.ch/private/common/photos/links/' + comment.comment_owner_sciper + '.jpg'"
        onerror="this.onerror=null;this.src='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cGF0aCBkPSJNMTAyLjQzIDEyNC41M1MxMDUuNSAxNTIgMTI4IDE1MnMyNS41Ny0yNy40NiAyNS41Ny0yNy40NiA0Ljg1IDEgNy4xOS05LjI4YzEuNS02LjctLjUtOC40OS0xLjc2LTguNDloLTEuMkMxNjMuNjggNzQuMjggMTQwIDY0IDEyOCA2NHMtMzUuNjggMTAuMjgtMjkuOCA0Mi43Nkg5N2MtMS4yNiAwLTMuMjYgMS43OS0xLjc2IDguNDkgMi4zNCAxMC4zMyA3LjE5IDkuMjggNy4xOSA5LjI4ek0xNzAuMzYgMTY0Yy0yMC4yNi0zLjg5LTI0LjM0LTgtMjUuMS0xMS42NGEyOS4xNSAyOS4xNSAwIDAgMS0zNC41MiAwYy0uNzQgMy42NC00Ljg0IDcuNzItMjUuMSAxMS42NC0yMC44NSA0LTIwLjU3IDIxLjE4LTIwLjU3IDI0aDEyNS44NmMwLTIuODUuMjgtMjAtMjAuNTctMjR6Ii8+PC9zdmc+Cg==';"
        alt="avatar"
      >
    </v-list-tile-avatar>
    <v-list-tile-avatar v-else>
      <v-layout align-center>
        <v-flex xs12 sm4 text-xs-center>
          <v-btn flat icon color="success" @click="updateComment">
            <v-icon>check</v-icon>
          </v-btn>
          <v-btn flat icon color="primary" @click="deleteComment">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-list-tile-avatar>

    <v-list-tile-content v-if="editingComment.id === comment.comment_id">
      <v-list-tile-title style="height: 100px;">
        <v-textarea v-model="editingComment.text" solo box></v-textarea>
      </v-list-tile-title>

      <v-list-tile-sub-title style="height: 100px;">
        <v-checkbox v-model="editingComment.isPrivate" label="Privé" color="primary"></v-checkbox>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-content v-else>
      {{ comment.comment_content }}
      <v-list-tile-sub-title>{{comment.ownerData.displayname}}</v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <div v-if="comment.comment_owner_sciper === $store.state.moduleUser.userData.tequila.sciper">
        <v-tooltip bottom v-if="comment.comment_id !== editingComment.id">
          <template v-slot:activator="{ on }">
            <v-chip
              v-on="on"
              color="primary"
              outline
              small
              @click="toggleEditComment(comment.comment_id, comment.comment_content, comment.comment_is_private)"
            >
              <v-icon small>edit</v-icon>
            </v-chip>
          </template>
          <span>Editer</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <v-icon small>edit</v-icon>
            <v-chip
              v-on="on"
              color="primary"
              outline
              small
              @click="toggleEditComment(null, '', false)"
            >
              <v-icon small>cancel</v-icon>
            </v-chip>
          </template>
          <span>Annuler</span>
        </v-tooltip>
      </div>
      <small>{{getFormatedDate(comment.comment_date)}}</small>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  name: 'application-comment-item',
  props: {
    comment: Object
  },
  data() {
    return {
      editingComment: {
        id: null,
        text: '',
        isPrivate: false
      }
    }
  },
  methods: {
    getFormatedDate(value) {
      let dateTimeParts = value.split(/[- :]/)
      dateTimeParts[1]--
      let date = new Date(...dateTimeParts)
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' à ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
    },
    toggleEditComment(id, content, isPrivate) {
      this.editingComment.id = id
      this.editingComment.text = content
      this.editingComment.isPrivate = isPrivate
    },
    updateComment() {
      this.$store.dispatch('moduleApplications/updateComment', { id: this.editingComment.id, content: this.editingComment.text, isPrivate: this.editingComment.isPrivate })
        .then(() => {
          this.$store.dispatch('moduleApplications/getCurrentApplicationComments', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
          this.toggleEditComment(null, '', false)
        })
    },
    deleteComment() {
      this.$store.dispatch('moduleApplications/deleteComment', { id: this.editingComment.id })
        .then(() => {
          this.$store.dispatch('moduleApplications/getCurrentApplicationComments', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
          this.toggleEditComment(null, '', false)
        })
    }
  }
}
</script>
